import type { PartnerDto } from "common/models/api/models/PartnerDto";
import useGetGiftCardsKpis from "features/giftcards/hooks/useGetGiftCardsKpis";
import { useState } from "react";
import { KpisRoot } from "ui/common/components/display/Kpis/Kpis.styles";
import KPICardSkeleton from "ui/common/components/feedback/KPICardSkeleton/KPICardSkeleton";
import KPICard from "ui/common/components/surface/KPICard/KPICard";
import { KPIQueryCard } from "ui/common/components/surface/KPIQueryCard/KPIQueryCard";
import Group from "ui/common/components/util/Group/Group";
import useSearchParam from "ui/common/hooks/useSearchParam";
import useTranslate from "ui/locale/hooks/useTranslate";
import PartnerAutocomplete from "ui/partner/container/PartnerAutocomplete/PartnerAutocomplete";

export const GiftCardsKpis = () => {
    const { data, isLoading } = useGetGiftCardsKpis();
    const QUERY_PARTNER = "partner" as const;
    const [query, setQuery] = useSearchParam(QUERY_PARTNER);
    const translate = useTranslate();
    const [partner, setPartner] = useState<PartnerDto>();

    if (isLoading && !data) {
        return (
            <KpisRoot>
                <Group Component={KPICardSkeleton} count={5} />
            </KpisRoot>
        );
    }

    return (
        <KpisRoot>
            <KPIQueryCard label={translate("filterByPartner")} tooltipText={translate("partnersWithVouchersTooltip")}>
                <PartnerAutocomplete
                    style={{ minWidth: "340px" }}
                    placeholder={translate("giftCardPartnerAddress")}
                    name="partner"
                    partnerType="giftcard"
                    defaultSearch={query}
                    value={partner}
                    onSearchChange={(e) => {
                        if (typeof e === "string" && e.length === 0) {
                            setQuery(undefined); // skipcq: JS-W1042
                        }
                    }}
                    onChange={(e: unknown) => {
                        const partner = e as PartnerDto;
                        setPartner(partner);
                        setQuery(partner.address);
                    }}
                />
            </KPIQueryCard>
            <KPICard
                tooltipText={translate("redeemedKPITooltip")}
                kpi={translate("redeemedKPI")}
                value={data?.byStatus?.REDEEMED?.count || 0}
            />
            <KPICard
                tooltipText={translate("notRedeemedKPITooltip")}
                kpi={translate("notRedeemedKPI")}
                value={data?.byStatus?.AVILABLE?.count || 0}
            />
            <KPICard
                tooltipText={translate("nearExpiryKPITooltip")}
                kpi={translate("nearExpiryKPI")}
                value={data?.nearExpiry?.count || 0}
            />
            <KPICard
                tooltipText={translate("cancelledKPITooltip")}
                kpi={translate("cancelledKPI")}
                value={data?.byStatus?.CANCELLED?.count || 0}
            />
        </KpisRoot>
    );
};
